import script from "./DropdownMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownMenu.vue?vue&type=script&setup=true&lang=ts"

import "./DropdownMenu.vue?vue&type=style&index=0&id=49dd26df&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49dd26df"]])

export default __exports__